// extracted by mini-css-extract-plugin
export default {"card":"Cart_card__PfOcn","qtyInCart":"Cart_qtyInCart__idKyR","totalPrice":"Cart_totalPrice__Ha1G-","button":"Cart_button__2yeKs","svg":"Cart_svg__twXbO"};